import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/role', [
    {
      path: '',
      name: 'role',
      redirect: { name: 'role-list' },
    },
    {
      path: '/list',
      name: 'role-list',
      component: () => import('@/views/role/RoleList.vue'),
    },
    {
      path: '/create',
      name: 'role-create',
      component: () => import('@/views/role/RoleCreate.vue'),
    },
    {
      path: '/:id(\\d+)',
      name: 'role-edit',
      component: () => import('@/views/role/RoleEdit.vue'),
    },
  ]);
};
